export default "__VITE_ASSET__sSoySxft__";